module.exports = vendor_27d241ede5a1387aae38;